// @ts-nocheck
import {Button, Modal, ModalBody, ModalFooter, Input, FormGroup, Label, FormText} from "reactstrap";
import React, {FunctionComponent, useState, useEffect} from "react";
import {CSSTransition} from "react-transition-group";
import store from "../../../store/store";
import {created} from "../redux/raiAnagraficaPoste.actions";
import GraphqlClient from "../../../client/graphql.client";

import {TextInputHook} from "../../../hooks/text_input.hook";
import {CheckBoxInputHook} from "../../../hooks/checkbox.hook";

const RaiAnagraficaPosteCreateComponent: FunctionComponent = (props: any) => {


    const email = TextInputHook("");
    const cap = TextInputHook("");
    const piano = TextInputHook("");
    const nome = TextInputHook("");
    const cognome = TextInputHook("");
    const indirizzo = TextInputHook("");
    const citta = TextInputHook("");
    const stanza = TextInputHook("");
    const emailPreventiva = CheckBoxInputHook(false);
    const descrizione = TextInputHook("");
    const societa = TextInputHook("");

    const [submitError, setSubmitError] = useState(false);
    const [loading, setLoading] = useState(false);

    const salva = async () => {
        try {
            setLoading(true);

            const res = await GraphqlClient.creaAnagraficaPoste(
                {
                    email: email.getValue(),
                    cap: cap.getValue(),
                    piano: piano.getValue(),
                    nome: nome.getValue(),
                    cognome: cognome.getValue(),
                    indirizzo: indirizzo.getValue(),
                    citta: citta.getValue(),
                    stanza: stanza.getValue(),
                    emailPreventiva: emailPreventiva.getValue(),
                    descrizione: descrizione.getValue(),
                    societa: societa.getValue()
                }
            );

            store.dispatch(created(res.creaAnagraficaPoste)); // scommentare per abilitare redux: al posto di res.getDpiArticles mettere l'oggetto con i dati
        } catch (e) {
            console.error(e);
            setSubmitError(true);
        } finally {
            setLoading(false);
        }

        props.toggle();
    };

    useEffect(() => {
        if (submitError) {
            const timer = setTimeout(() => {
                setSubmitError(false);
            }, 3000);
            return () => clearTimeout(timer);
        }

    }, [submitError]);

    return (
        <Modal
            modalClassName="modal-black"
            isOpen={props.show}
            toggle={props.toggle}
        >
            <div className="modal-header justify-content-center">
                <button
                    aria-hidden={true}
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggle}
                >
                    <i className="tim-icons icon-simple-remove"/>
                </button>
                <h6 className="title title-up">Nuovo</h6>
            </div>
            <ModalBody>
                <form onSubmit={e => {
                    e.preventDefault();
                    salvaLotto();
                }}>
                    <FormGroup>
                        <Label for="descrizione">Descrizione</Label>
                        <Input
                            {...descrizione.input}
                            name="descrizione"
                            id="descrizione"
                            placeholder="Inserisci descrizione"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="nome">Nome</Label>
                        <Input
                            {...nome.input}
                            name="nome"
                            id="nome"
                            placeholder="Inserisci nome"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="cognome">Cognome</Label>
                        <Input
                            {...cognome.input}
                            name="cognome"
                            id="cognome"
                            placeholder="Inserisci cognome"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input
                            {...email.input}
                            name="email"
                            id="email"
                            placeholder="Inserisci email"
                        />
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                            <Input
                                {...emailPreventiva.input} type="checkbox"/>
                            Email preventiva
                            <span className="form-check-sign">
                        <span className="check"></span>
                     </span>
                        </Label>
                    </FormGroup>
                    <FormGroup>
                        <Label for="indirizzo">Indirizzo</Label>
                        <Input
                            {...indirizzo.input}
                            name="indirizzo"
                            id="indirizzo"
                            placeholder="Inserisci indirizzo"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="citta">Citta</Label>
                        <Input
                            {...citta.input}
                            name="citta"
                            id="citta"
                            placeholder="Inserisci citta"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="cap">Cap</Label>
                        <Input
                            {...cap.input}
                            name="cap"
                            id="cap"
                            placeholder="Inserisci cap"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="piano">Piano</Label>
                        <Input
                            {...piano.input}
                            name="piano"
                            id="piano"
                            placeholder="Inserisci piano"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="stanza">Stanza</Label>
                        <Input
                            {...stanza.input}
                            name="stanza"
                            id="stanza"
                            placeholder="Inserisci stanza"
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label for="societa">Societa</Label>
                        <Input
                            {...societa.input}
                            name="societa"
                            id="societa"
                            placeholder="Inserisci societa"
                        />
                    </FormGroup>

                    {/*Il button serve solo per permettere il submit del form con il pulsante enter */}
                    <button style={{display: 'none'}} type="submit"/>
                </form>
                <CSSTransition
                    in={submitError}
                    appear={true}
                    unmountOnExit
                    classNames="error"
                    timeout={300}
                >
                    <blockquote className="blockquote blockquote-danger">
                        <p className="mb-0 text-danger">Errore durante il salvataggio.</p>
                    </blockquote>
                </CSSTransition>

            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggle}
                >
                    Annulla
                </Button>
                <Button
                    color="primary"
                    type="button"
                    onClick={salva}
                >
                    {loading ?
                        <i className="fa fa-spin fa-spinner"/>
                        : 'Salva'}
                </Button>
            </ModalFooter>
        </Modal>
    );

}

export default RaiAnagraficaPosteCreateComponent;
